import React from 'react';
import { Row, Col, Button, Tooltip } from 'reactstrap';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

// data convertion
const getItems = schema =>
  schema ? schema.map((a, index) => ({
    id: `pctitle-${a.index}`,
    content: `${a.text}`,
    index,
  })) : [];

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 10;
//const scoreColor = ['#1e7e34', '#fb8072', '#007bff', '#fb8072', '#007bff'];
const scoreColor = ['#7bff00', '#15ff00', '#00ff51', '#00ffb7', '#00e1ff', '#007bff', '#0015ff', '#5100ff', '#b700ff', '#ff00e1', '#ff007b'];
//const scoreColor = ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'];

const getItemStyle = (isActive, isDragging, draggableStyle, sizeFactor, isEndItem, panelWidth, value) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  //padding: 0,
  padding: '-5px 0px 5px 0px',
  //margin: `0 ${grid * sizeFactor + (panelWidth && !isEndItem ? (panelWidth - 600 * sizeFactor) / 5 : 0)}px 0 0`,
  margin: `-5px ${grid * sizeFactor + (panelWidth && !isEndItem ? (panelWidth - 600 * sizeFactor) / 5 : 0)}px 5px 0`,
  //width: `${80 * sizeFactor}px`,
  width: `${100 * sizeFactor}px`,
  //height: `${25 * sizeFactor}px`,
  height: `${30 * sizeFactor}px`,
  textAlign: 'center',
  //color: '#fff',
  color: scoreColor[value !== undefined ? value : 0],
  //borderRadius: `${.25 * sizeFactor}rem`,
  borderRadius: `${.5 * sizeFactor}rem`,
  cursor: 'pointer',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  fontSize: `${18 * sizeFactor}px`,
  fontWeight: 600,

  // change background colour if dragging
  //background: isDragging ? '#1e7e34' : isActive ? '#fb8072' : '#007bff',
  background: isDragging ? '#fbb' : isActive ? '#bbb' : '#fff',
  border: `solid ${2 * sizeFactor}px ${scoreColor[value !== undefined ? value : 0]}`,

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver, sizeFactor) => ({
  display: 'flex',
  //padding: `${10 * sizeFactor}px ${20 * sizeFactor}px ${10 * sizeFactor}px ${50 * sizeFactor}px`,
  padding: `${10 * sizeFactor}px ${30 * sizeFactor}px ${5 * sizeFactor}px ${50 * sizeFactor}px`,
  overflow: 'auto',
});

class ParallelOrderArea extends React.Component {
  constructor(props) {
    super();
    this.state = {
      tooltip: false,
    };
  }

  onDragEnd = ((result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    let {settings} = this.props;
    settings = reorder(
      settings,
      result.source.index,
      result.destination.index
    );

    this.props.onChange(settings);
  }).bind(this)

  render() {
    let {sizeFactor} = this.props;
    if(!sizeFactor) sizeFactor = 1;
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable" direction="horizontal">
          {(provided, snapshot) => (
            <div
              id='pcarea-zone'
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver, sizeFactor)}
              {...provided.droppableProps}
            >
              {this.props.settings.map((item, index) => (
                <Draggable key={`pctitle-${item.index}`} draggableId={`pctitle-${item.index}`} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(
                        this.props.active === item.name,
                        snapshot.isDragging,
                        provided.draggableProps.style,
                        sizeFactor,
                        index === this.props.settings.length - 1,
                        this.props.width,
                        this.props.values[item.index]
                      )}
                      onClick={() => this.props.onToggle(item.index, this.props.active !== item.name)}
                    >
                      {[item.icon, ' ' + this.props.values[item.index]]}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        <Tooltip
          placement="top"
          isOpen={this.state.tooltip}
          target='pcarea-zone'
          toggle={(() => this.setState({
            tooltip: !this.state.tooltip
          })).bind(this)}
        >Drag to reorder, click for information</Tooltip>
      </DragDropContext>
    )
  }
}

export default ParallelOrderArea;
